import React, { useState, useEffect } from 'react';
import InnerHeader from './InnerHeader';
import { BASE_URL } from './BaseUrl';
import axios from "axios";
import { Link, useParams } from 'react-router-dom';
import decryptedUserId from '../Utils/UserID';

const LeaveStructure = () => {
 const { empolyeeid } = useParams();
     const [rows, setRows] = useState([]);
 
     useEffect(() => {
             if (empolyeeid) {
                 fetch_employee_leave_structureData();
             }
         }, [empolyeeid]);
         
         console.log("Fetching academic data for empolyeeid:", empolyeeid);
         
         
            const formatDate = (inputDate) => {
  if (!inputDate) return '';
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = (`0${date.getMonth() + 1}`).slice(-2);
  const day = (`0${date.getDate()}`).slice(-2);
  return `${year}-${month}-${day}`; // ✅ Browser-friendly format
};

const fetch_employee_leave_structureData = async () => {
  try {
    const res = await axios.post(`${BASE_URL}/get_employee_leavestructure`, { empolyeeid });
    const data = res.data;

    console.log("Leave Structure Data:", data);

    if (data && data.length > 0) {
      const formattedData = data.map(item => ({
        ...item,
        FromDate: formatDate(item.FromDate),
        ToDate: formatDate(item.ToDate),
        AttainDate: formatDate(item.AttainDate)
      }));
      setRows(formattedData);
    } else {
      setRows([{
        LeaveID: '',
        PrivilegeLeave: '',
        SickLeave: '',
        CasualLeave: '',
        FromDate: '',
        ToDate: '',
        AttainDate: ''
      }]);
    }
  } catch (err) {
    console.error("Error fetching leave structure:", err);
  }
};

 

         
           
         
           const handleInputChange = (e, index) => {
             const { name, value } = e.target;
             const updatedRows = [...rows];
     updatedRows[index][name] = value;
     setRows(updatedRows);
     
           };
         
           const addNewRow = () => {
             setRows([
               ...rows,
              {
    PrivilegeLeave: '',
    SickLeave: '',
    CasualLeave: '',
    FromDate: '',
    ToDate: '',
    AttainDate: ''
  }
             ]);
           };
         
           
         
        const handleSave = async (e) => {
  e.preventDefault();

  const record = rows[0];

  if (
  record.PrivilegeLeave === '' ||
  record.SickLeave === '' ||
  record.CasualLeave === '' ||
  !record.FromDate ||
  !record.ToDate ||
  !record.AttainDate
) {
  alert("Please fill in all required fields.");
  return;
}


  const data = {
  empolyeeid: empolyeeid,
  createdBy: decryptedUserId(),
  updatedBy: decryptedUserId(),
  records: rows.map((record) => ({
    LeaveID: record.LeaveID || null,  // NULL for new insert
    PrivilegeLeave: record.PrivilegeLeave,
    SickLeave: record.SickLeave,
    CasualLeave: record.CasualLeave,
    FromDate: formatDateToYYYYMMDD(record.FromDate),
    ToDate: formatDateToYYYYMMDD(record.ToDate),
    AttainDate: formatDateToYYYYMMDD(record.AttainDate)
  }))
};


  try {
    const res = await axios.post(`${BASE_URL}/save_or_update_employee_leave_structure`, data);

    if (res.data.success) {
      alert("Leave record saved successfully!");
      fetch_employee_leave_structureData(); // Refresh function
    } else {
      alert("Failed to save leave record: " + res.data.message);
    }
  } catch (err) {
    console.error("Error saving leave record:", err);
    alert("An error occurred while saving.");
  }
};


     
     // 🔧 Helper function to convert to YYYY-MM-DD
     function formatDateToYYYYMMDD(dateString) {
         const date = new Date(dateString);
         if (isNaN(date)) return ""; // handle invalid date
         const year = date.getFullYear();
         const month = (`0${date.getMonth() + 1}`).slice(-2); // pad with 0
         const day = (`0${date.getDate()}`).slice(-2);
         return `${year}-${month}-${day}`;
     }
     
         
           const handleCancelRow = (indexToRemove) => {
             const updatedRows = rows.filter((_, index) => index !== indexToRemove);
             setRows(updatedRows);
           };
 
     const activeEmpId = (empolyeeid && empolyeeid !== ":empolyeeid" && empolyeeid !== "undefined") ? empolyeeid : ":empolyeeid";

     return (
         <div className="container-fluid page-body-wrapper">
             <InnerHeader />
             <div className="main-panel">
                 <div className="content-wrapper">
                     <div className="d-flex flex-wrap">
                         <div className='px-2 mx-2'><Link to={`/employeepersonaldetails/${activeEmpId}`}><h4>Personal Information</h4></Link></div>
                         <div className='px-2 mx-2'><Link to={`/emailcredential/${activeEmpId}`}><h4>Email Credential</h4></Link></div>
                         <div className='px-2 mx-2'><Link to={`/academicqualificationsemp/${activeEmpId}`}><h4>Academic Qualification</h4></Link></div>
                         <div className='px-2 mx-2'><Link to={`/workexperience/${activeEmpId}`}><h4>Work Experience</h4></Link></div>
                         <div className='px-2 mx-2'><Link to={`/leavestructure/${activeEmpId}`}><h4>Leave Structure</h4></Link></div>
                         <div className='px-2 mx-2'><Link to={`/salarystructure/${activeEmpId}`}><h4>Salary Structure</h4></Link></div>
                         <div className='px-2 mx-2'><Link to={`/weeklyoff/${activeEmpId}`}><h4>Weekly Off</h4></Link></div>
                         <div className='px-2 mx-2'><Link to={`/intimesetting/${activeEmpId}`}><h4>Intime Setting</h4></Link></div>
                     </div>
 
                     <div className="col-lg-12 grid-margin stretch-card mt-4">
                         <div className="card">
                             <div className="card-body">
                                 <h2 className="card-title titleback">Leave Structure</h2>
                                 <hr />
 
                                 {rows.map((row, index) => (
                                     <div key={index} className="border p-3 mb-4 rounded bg-light">
                                         <div className="row">
                                             <div className="col-md-2">
                                                 <label>P.L</label>
                                                 <input type="text" className="form-control" name="PrivilegeLeave" value={row.PrivilegeLeave} onChange={(e) => handleInputChange(e, index)} />
                                             </div>
                                             <div className="col-md-2">
                                                 <label>S.L</label>
                                                 <input type="text" className="form-control" name="SickLeave" value={row.SickLeave} onChange={(e) => handleInputChange(e, index)} />
                                             </div>
                                             <div className="col-md-2">
                                                 <label>C.L</label>
                                                 <input type="text" className="form-control" name="CasualLeave" value={row.CasualLeave} onChange={(e) => handleInputChange(e, index)} />
                                             </div>
                                             <div className="col-md-2">
                                                 <label>From Date</label>
                                                 <input type="date" className="form-control" name="FromDate" value={row.FromDate} onChange={(e) => handleInputChange(e, index)} />
                                             </div>
                                             <div className="col-md-2">
                                                 <label>To Date</label>
                                                 <input type="date" className="form-control" name="ToDate" value={row.ToDate} onChange={(e) => handleInputChange(e, index)} />
                                             </div>
                                             
                                             <div className="col-md-2">
                                                 <label>Attain Date</label>
                                                 <input type="date" className="form-control" name="AttainDate" value={row.AttainDate} onChange={(e) => handleInputChange(e, index)} />
                                             </div>
                                         </div>
 
                                       
 
                                         <div className="row mt-3">
                                             <div className="col-md-3 d-flex align-items-end">
                                                 <button className="btn btn-danger btn-sm" onClick={() => handleCancelRow(index)}>Remove</button>
                                             </div>
                                         </div>
                                     </div>
                                 ))}
 
                                 <div className="mt-4">
                                     <button type="button" className="btn btn-success" onClick={addNewRow}>Add Row</button>
                                     <button type="submit" className="btn btn-primary mx-2" onClick={handleSave}>Save</button>
                                     <button type="button" className="btn btn-light" onClick={() => window.location.reload()}>Close</button>
                                 </div>
 
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
         </div>
     );
}

export default LeaveStructure